<template>
  <svg viewBox="0 0 14 15" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.2761 3.10948C13.7968 2.58878 13.7968 1.74456 13.2761 1.22386C12.7554 0.703159 11.9112 0.703159 11.3905 1.22386L6.99998 5.61438L2.60946 1.22386C2.08876 0.703159 1.24454 0.703159 0.723837 1.22386C0.203138 1.74456 0.203138 2.58878 0.723837 3.10948L5.11436 7.5L0.723837 11.8905C0.203138 12.4112 0.203138 13.2554 0.723837 13.7761C1.24454 14.2968 2.08876 14.2968 2.60946 13.7761L6.99998 9.38562L11.3905 13.7761C11.9112 14.2968 12.7554 14.2968 13.2761 13.7761C13.7968 13.2554 13.7968 12.4112 13.2761 11.8905L8.8856 7.5L13.2761 3.10948Z"
    />
  </svg>
</template>
